import React, { useState, useContext } from 'react';
import {
  productsForSearchPageGenreAndClusters,
  getProductForEan,
  getProductForNumber,
  getProductForMaterialNumber,
} from '../../selectors';

import { DebouncedInput } from '../../Components';
import AppContext from '../../AppContext';
import {
  isSearchByEan,
  isSearchByNumber,
  isSearchByMaterialNumber,
} from '../../utils/products';

const getProductsForSearchAndPage = (
  search,
  context,
  page,
  genre,
  clusters,
) => {
  let products;

  if (isSearchByNumber(search)) {
    products = { data: [getProductForNumber(context)(Number(search))] };
  } else if (isSearchByEan(search)) {
    products = getProductForEan(context)(search);
  } else if (isSearchByMaterialNumber(search)) {
    products = getProductForMaterialNumber(context)(search);
  } else {
    products = productsForSearchPageGenreAndClusters(context)(
      search,
      page,
      genre,
      clusters,
    );
  }
  return products;
};

const getSearchFunction = (setSearch, onSearch) => (value) => {
  setSearch(value);
  onSearch(value);
};

export const WithProductsSearchWithInput = ({ ...props }) => (
    <WithProductsSearch
      {...props}
      renderInputComponent={({ search, handleSearch }) => (
        <DebouncedInput value={search} onChange={handleSearch} />
      )}
    />
);

export const WithProductsSearch = ({
  onSearch,
  children,
  page,
  defaultSearch,
  renderInputComponent,
  clusters,
  genre,
}) => {
  const [search, setSearch] = useState(defaultSearch);
  const context = useContext(AppContext);

  const products = getProductsForSearchAndPage(
    search,
    context,
    page,
    clusters,
    genre,
  );

  return (
    <>
      {renderInputComponent({
        search,
        handleSearch: getSearchFunction(setSearch, onSearch),
      })}
      {children({ products, search, setSearch })}
    </>
  );
};

WithProductsSearch.defaultProps = {
  renderInputComponent: () => null,
  onSearch: () => {},
};

export default WithProductsSearch;
